import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles((theme) => ({
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
    cursor: 'pointer',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
    cursor: 'pointer',
  },
}));

const StatusField = ({ handleEfetivar, ...props }) => {
  const classes = useStyles();
  const record = useRecordContext(props);

  const isColaborador = record ? record.record.is_colaborador : false;

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {isColaborador ? (
        <Avatar className={classes.confirmado}>
          <PersonIcon style={{ fontSize: 15 }} />
        </Avatar>
      ) : null}
    </div>
  );
};

export default StatusField;
